/* eslint-disable react/no-children-prop */
import {Box} from '@mui/material';
import EStoreProductDetailAboutGame, {
  IEStoreProductDetailAboutGame,
} from '@wearesection/bandai-react-components/organisms/EStoreProductDetailAboutGame';

// import EStoreProductDetailAboutGameCustomize, {
//   IEStoreProductDetailAboutGameCustomize,
// } from '@wearesection/bandai-react-components/organisms/EStoreProductDetailAboutGameCustomize';

import EStoreProductDetailGameSpecs, {
  IEStoreProductDetailGameSpecs,
} from '@wearesection/bandai-react-components/organisms/EStoreProductDetailGameSpecs';
import React, {ReactNode, useEffect, useState} from 'react';
import getContentGameOnContentFull from './get-content-game-in-contentfull';
import {
  GetRouter,
  handleConvertToLocaleContentful,
  handleTranslateGameGenres,
  handleTranslateGameLanauges,
} from '~/utils';
import {handleReturnDateForLocal} from '../scrolling-thumbnail-card/scrolling-thumbnail-card';
import {PLACEHOLDER_IMG} from '~/constants';
import RenderNextImage from '~/components/wrapper/atoms/render-next-image';
import ReactMarkdown from 'react-markdown';
import { IAgeRatingPopup } from '../age-rating-pop-up';
import AgeRatingPopupOrganisms from '../age-rating-pop-up/age-rating-pop-up';

type IProps = {
  sku: string;
  description?: ReactNode | string;
  dataTranslation: any;
};

const EStoreProductDetailGameSpecsOrganisms: React.FC<IProps> = ({
  sku,
  dataTranslation,
  description,
}) => {
  const {locale} = GetRouter();
  const [positionLettering, setPositionLettering] = useState(-1);

  const [dataProductDetailGameSpecs, setDataProductDetailGameSpecs] =
    useState<IEStoreProductDetailGameSpecs>({
      titleCompareEdition:
        dataTranslation?.['estore-products-detail-title-game-specs'] || 'Game specs',
      gameDetailInformation: {
        listProps: [],
      },
    });

  const [dataProductDetailAboutGame, setDataProductDetailAboutGame] =
    useState<IEStoreProductDetailAboutGame>({
      titleCompareEdition:
        dataTranslation?.['estore-products-detail-title-about-the-game'] || 'About the game',
      gameShortDescription: {
        title: '',
        description: '',
        mainImage: '',
      },
      contentBonus: {},
    });

  const [noneData, setNoneData] = useState<boolean>(false);
  const [ageRatingPopup, setAgeRatingPopup] = useState<IAgeRatingPopup>({
    title: '',
    description: '',
    atLeastAgeLabel: '',
    notYetAgeLabel: '',
    isOpen: false,
  });
  useEffect(() => {
    if (sku) {
      getContentGameOnContentFull(sku, handleConvertToLocaleContentful(locale as string)).then(
        (res: any) => {
          if (!res?.length) {
            setNoneData(true);
            return;
          }

          const itemContent = res[0];
          const AgeRatingPopup = {
            title: dataTranslation['game-restricted-age-title'] ?? '',
            description: dataTranslation['game-restricted-age-description'] ?? '',
            atLeastAgeLabel: dataTranslation['game-restricted-age-at-least-age-label'] ?? '',
            notYetAgeLabel: dataTranslation['game-restricted-age-not-yet-age-label'] ?? '',
            isOpen: itemContent?.restrictAge || false,
            urlBack: `/${locale}/store/games`,
          };
          setAgeRatingPopup(AgeRatingPopup);
          const listMastheadGallery: any[] =
            itemContent?.mastheadGalleryAboutGameCollection?.items || [];
          //   content Game specs
          const newDataProductDetailGameSpecs = {
            ...dataProductDetailGameSpecs,
            gameDetailInformation: {
              listProps: [
                {
                  id: 1,
                  title: dataTranslation['game-detailed-game-info-release-date'],
                  detail: itemContent?.releaseDate
                    ? handleReturnDateForLocal(
                        locale || '',
                        `${itemContent?.releaseDate}`.substring(0, 10)
                      )
                    : 'To be announced',
                },
                {
                  id: 2,
                  title: dataTranslation['game-detailed-game-info-release-developer'],
                  detail: itemContent?.developer,
                },
                {
                  id: 3,
                  title: dataTranslation['game-detailed-game-info-release-genre'],
                  detail:
                    handleTranslateGameGenres(itemContent?.genre, dataTranslation)?.join(', ') ??
                    '',
                },
                {
                  id: 4,
                  title: dataTranslation['game-detailed-game-info-release-platform'],
                  detail: itemContent?.platform?.join(', ') ?? '',
                },
                {
                  id: 5,
                  title: dataTranslation['game-detailed-game-info-release-subtitle'],
                  detail:
                    handleTranslateGameLanauges(itemContent?.subtitle, dataTranslation)?.join(
                      ', '
                    ) ?? '',
                },
                {
                  id: 6,
                  title: dataTranslation['game-detailed-game-info-release-audio'],
                  detail:
                    handleTranslateGameLanauges(itemContent?.audio, dataTranslation)?.join(', ') ??
                    '',
                },
              ],
            },
          };
          // content About Game
          const newDataProductDetailAboutGame = {
            ...dataProductDetailAboutGame,
            gameShortDescription: {
              title: itemContent?.overviewTitle || '   ',
              description: (
                <Box
                  sx={{
                    '& p': {
                      margin: '0px',
                      padding: '0px',
                    },
                  }}
                >
                  <ReactMarkdown children={itemContent?.overviewDescription ?? ''} />
                </Box>
              ),
              mainImage: itemContent?.overviewKeyImage?.media?.url ?? PLACEHOLDER_IMG,
              nextImage: (
                <RenderNextImage
                  src={itemContent?.overviewKeyImage?.media?.url || PLACEHOLDER_IMG}
                  width={1029}
                  height={750}
                />
              ),
            },
            contentBonus: {
              listImg: listMastheadGallery.length
                ? listMastheadGallery.map((item: any) => {
                    return {
                      hefImg: item?.media?.url || PLACEHOLDER_IMG,
                    };
                  })
                : [],
            },
          };
          setDataProductDetailAboutGame(newDataProductDetailAboutGame);
          setDataProductDetailGameSpecs(newDataProductDetailGameSpecs);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sku, dataTranslation, locale]);

  // Handle check short code for descriptions
  useEffect(() => {
    if (description) {
      const position = (description as string).search(/\[overview\]/);
      if (position !== -1) {
        setPositionLettering(position);
      } else {
        setPositionLettering(-1);
      }
    }
  }, [description]);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: {
          xs: '24px',
          md: '0px',
        },
      }}
    >
      {noneData ? '' : <EStoreProductDetailGameSpecs {...dataProductDetailGameSpecs} />}

      {description && (
        <Box
          sx={{
            img: {
              width: '100% !important',
              height: 'auto',
              margin: {
                xs: '12px 0px',
                md: '24px 0px',
              },
              borderRadius: {
                xs: '10px',
                md: '20px',
              },
            },
          }}
        >
          <EStoreProductDetailAboutGame
            {...dataProductDetailAboutGame}
            pullData={!(positionLettering === -1)}
            description={description ?? ''}
            htmlRender
          />
          <AgeRatingPopupOrganisms {...ageRatingPopup} />
        </Box>
      )}
      
    </Box>
  );
};

export default EStoreProductDetailGameSpecsOrganisms;
